export enum LoginEnum {
  // LoginInfo = "loginInfo",
  Token = "token",
}
